<div class="modal-header d-flex align-items-center justify-content-center position-relative">
    <div><span class="font-semibold text-primary">{{!data?.editCategory?.id ? masterModalTitle.AddCategory : masterModalTitle.EditCategory}}</span></div>
    <app-svg-icon [name]="'cross_button_border'" class="cross-button-border"></app-svg-icon>
    <app-svg-icon [name]="'cross'" [ngClass]="currentHoverEffect" class="cross-button" (click)="activeModal.dismiss()"></app-svg-icon>
  </div>
  <form>
    <div class="modal-body mx-2">
      <div class="row mb-1">
        <div class="col-12 d-flex mb-2 gap-0">
          <div class="w-115px font-semibold text-gray-color d-flex align-items-center">Name<span class="text-color-danger">*</span></div>
          <div class="col">
              <app-input 
              [inputName]="'categoryName'" 
              [inputId]="'categoryName'" 
              [inputType]="'text'" 
              [inputValue]="insertCategoryRequestModel?.name"
              (inputValueEmit)="insertCategoryRequestModel.name = $event"
              (keydown.enter)="onKeydown($event, 'shortCode')"
              >
            </app-input>
          </div>
        </div>
        <div class="col-12 d-flex mb-2 gap-0">
          <div class="w-115px font-semibold text-gray-color d-flex align-items-center">Short Code</div>
          <div class="col">
              <app-input 
              [inputName]="'shortCode'" 
              [inputId]="'shortCode'" 
              [inputType]="'text'" 
              [inputValue]="insertCategoryRequestModel?.shortCode"
              (inputValueEmit)="insertCategoryRequestModel.shortCode = $event"
              (keydown.enter)="onKeydown($event, 'parentCategoryId')"
              >
            </app-input>
          </div>
        </div>
        <div class="col-12 d-flex">
          <div class="col d-flex align-items-center mb-2">
            <div class="w-115px f-14 font-semibold text-gray-color text-nowrap mb-0">
             Parent Category
            </div>
            <div class="col">
              <app-custom-select2 
                #parentCategory 
                [customId]="'parentCategory'"
                [formModel]=""
                [whichDropdown]="storageName.CATEGORY_DROPDOWN"
                (valueChanged)="assignParentCategoryId($event)" 
                (keydown.enter)="onKeydown($event, 'minimumQty')"
                >
              </app-custom-select2>
            </div>
          </div>
          <div class="col-2 d-flex align-items-center ps-0">
            <div (click)="this.insertCategoryRequestModel.active = !this.insertCategoryRequestModel?.active;" class="col-9 f-14 font-semibold cursorPointer text-gray-color text-center text-nowrap ps-2 mb-0">
                Active
            </div>
            <div class="col d-flex justify-content-end align-items-center">
                <app-checkbox (keydown.enter)="onKeydown($event, 'userName')" [dyanamicId]="'active'" [status]="insertCategoryRequestModel?.active" (check)="insertCategoryRequestModel.active = $event"></app-checkbox>
            </div>
          </div>
        </div>
        <div class="col-12 d-flex gap-3 mb-2">
          <div class="col d-flex">
            <div class="w-115px f-14 font-semibold text-gray-color text-nowrap mb-0">
              Min. Qty.
            </div>
            <div class="col">
                  <app-input 
                  [isOnlyNumbers]="true"  
                  [inputName]="'minimumQty'" 
                  [inputType]="'text'" 
                  [inputId]="'minimumQty'"
                  [inputMaxlength]="10" 
                  [inputValue]="insertCategoryRequestModel?.minimumQty" 
                  (inputValueEmit)="insertCategoryRequestModel.minimumQty = $event"  
                  [isRequired]="false" 
                  (keydown.enter)="onKeydown($event, 'maximumQty')">
                  </app-input>
            </div>
          </div>
          <div class="col d-flex">
            <div class="w-115px f-14 font-semibold text-gray-color text-nowrap mb-0">
              Max. Qty.
            </div>
            <div class="col">
             <app-input 
              [isOnlyNumbers]="true"  
              [inputName]="'maximumQty'" 
              [inputType]="'text'" 
              [inputId]="'maximumQty'"
              [inputMaxlength]="10" 
              [inputValue]="insertCategoryRequestModel?.maximumQty" 
              (inputValueEmit)="insertCategoryRequestModel.maximumQty = $event"  
              [isRequired]="false" 
              (keydown.enter)="onKeydown($event, 'minimumGrossWt')">
              </app-input>
            </div>
          </div>
        </div>
        <div class="col-12 d-flex gap-3 mb-2">
          <div class="col d-flex">
            <div class="w-115px f-14 font-semibold text-gray-color text-nowrap mb-0">
              Min. Wt.
            </div>
            <div class="col">
              <app-input   
              [decimalRestrictedDigit]="3"
              [isBlureApplicable]="true"
              [applyDecimalOrPercent]="true"
              [inputName]="'minimumGrossWt'" 
              [inputType]="'text'" 
              [inputId]="'minimumGrossWt'"
              [inputMaxlength]="10"
              [inputValue]="insertCategoryRequestModel?.minimumGrossWt" 
              (inputValueEmit)="insertCategoryRequestModel.minimumGrossWt = $event"  
              [isRequired]="false"  
              (keydown.enter)="onKeydown($event, 'maximumGrossWt')">
              </app-input>
            </div>
          </div>
          <div class="col d-flex">
            <div class="w-115px f-14 font-semibold text-gray-color text-nowrap mb-0">
              Max. Wt.
            </div>
            <div class="col">
              <app-input   
              [decimalRestrictedDigit]="3"
              [isBlureApplicable]="true"
              [applyDecimalOrPercent]="true"
              [inputName]="'maximumGrossWt'" 
              [inputType]="'text'" 
              [inputId]="'maximumGrossWt'"
              [inputMaxlength]="10"
              [inputValue]="insertCategoryRequestModel?.maximumGrossWt" 
              (inputValueEmit)="insertCategoryRequestModel.maximumGrossWt = $event"  
              [isRequired]="false" 
              (keydown.enter)="addEditCategoryList()" 
              >
              </app-input>
            </div>
          </div>
        </div> 
      </div>
      <div class="row mx-0" *ngIf="modalTitle === masterModalTitle.EditCategory">
        <hr class="mb-2 mt-1 border-gray-1">
        <h5 class="text-primary font-semibold mb-3 mt-1 ps-0 f-15">
          Mapped Products
        </h5>
        <div class="col p-0">
          <div class="h-100 position-relative">
              <app-ag-grid 
              id="MappedProducts"
              [dataModel]="agGridDataModelMappedProducts" 
              [columnSettings]="true"
              (gridReady)="onGridReady($event)" 
              (onPagination)="onPagination($event)"
              (onSortIconClick)="onSortIconClick($event)"
              >
            </app-ag-grid>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer pt-3 pb-2 mx-2">
      <app-button class="my-0 me-3" (buttonOutputEvent)="activeModal?.close()" [buttonLabel]="'Close'" [buttonClass]="'light_button'" [buttonType]="'button'">
      </app-button>
      <app-button class="m-0" [buttonLabel]="'Save'" (buttonOutputEvent)="addEditCategoryList()" [buttonClass]="'blue_button'" [buttonType]="'submit'">
      </app-button>
    </div>
</form>
